import type { FieldTag } from '../types/FieldTag';
import { STANDARD_FIELD_TAGS } from '../types/FieldTag';

export class TagRegistry {
  private static instance: TagRegistry;
  private tags: Map<string, FieldTag> = new Map();

  private constructor() {
    STANDARD_FIELD_TAGS.forEach(tag => this.register(tag));
  }

  static getInstance(): TagRegistry {
    if (!TagRegistry.instance) {
      TagRegistry.instance = new TagRegistry();
    }
    return TagRegistry.instance;
  }

  register(tag: FieldTag): void {
    this.tags.set(tag.id, tag);
  }

  unregister(tagId: string): void {
    this.tags.delete(tagId);
  }

  get(tagId: string): FieldTag | undefined {
    return this.tags.get(tagId);
  }

  getAll(): FieldTag[] {
    return Array.from(this.tags.values());
  }

  getByCategory(category: string): FieldTag[] {
    return Array.from(this.tags.values()).filter(tag => tag.category === category);
  }

  has(tagId: string): boolean {
    return this.tags.has(tagId);
  }

  clear(): void {
    this.tags.clear();
    STANDARD_FIELD_TAGS.forEach(tag => this.register(tag));
  }
}

export const tagRegistry = TagRegistry.getInstance();
